<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false"
      :title="titleCreate">
    </page-nav-bar>
    <page-content
      :has-no-padd-on-act-on-desktop="true"
      :has-right-col-small="true"
      :has-sticky-col-right="true">
      <div class="has-background-white is-border">
        <form @submit.prevent.stop="submitDenunciation()">
          <div
            style="min-height: 260px"
            class="is-padding-bottom-small is-padding-left-large is-padding-right-large is-padding-top-xlarge">
            <div
              class="columns is-variable is-6">
              <div
                style="justify-content: flex-start; padding-bottom: 40px"
                class="column columns is-gapless is-column is-space-between is-marginless is-padding-top-large is-padding-left">
                <div v-if="program">
                  <r-label
                    style="font-size: 1.45rem !important"
                    class="has-text-grey title is-6 has-text-weight-normal"
                    :is-required="false"
                    :label="'Nom du Programme :'">
                    <span
                      v-if="program"
                      style="font-size: 1.5rem"
                      class="is-margin-left-xxsmall has-text-weight-bold has-text-black ">{{ program.name }} </span>
                  </r-label>
                </div>
                <div
                  class="is-margin-top"
                  v-if="canAddUsers && (isAdmin || isManager)">
                  <div
                    v-if="sellersCount !== null && sellersCount === 0"
                    class="column is-12 columns is-paddingless">
                    <div class="column is-12 is-margin-bottom-xsmall is-paddingless">
                      <div class="notification is-warning is-size-6 is-padding-top-small is-padding-bottom-small">
                        <p>Vous n'avez pas d'utilisateur.</p>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div
                      class="control field has-addons"
                      v-if="!seller">
                      <div class="control is-expanded">
                        <div
                          id="selfDenunciation"
                          class="button is-blocAdd is-fullwidth is-flex is-min-height-50"
                          :class="selfDenunciation ? 'is-success' : ''"
                          style="justify-content: center !important; font-size: 1.13rem"
                          @click="selfDenunciation = true">
                          <span :class="selfDenunciation ? 'has-text-white' : ' '">Cette dénonciation est pour moi</span>
                        </div>
                      </div>
                      <div class="control is-expanded">
                        <button
                          class="button is-blocAdd is-fullwidth"
                          style="justify-content: center !important; font-size: 1.13rem"
                          @click.prevent.stop="openUserSelection('simple'); selfDenunciation = false">
                          <span class="has-text-black">Sélectionner un vendeur</span>
                        </button>
                      </div>
                    </div>
                    <div
                      v-if="seller"
                      class="columns is-gapless is-border is-padding-left-xsmall is-padding-top-small is-padding-bottom-small is-padding-right-small">
                      <div class="column">
                        <div class="is-margin-left-xxsmall is-margin-right-xxsmall">
                          <div
                            style="height: 8px !important"
                            class="title is-4">
                            <b>{{ seller.first_name }} {{ seller.last_name }}</b>
                          </div>
                          <div class="rows">
                            <div
                              v-if="seller.account.pk !== currentUser.account.pk && seller.account.name"
                              class="subtitle is-size-6">
                              {{ seller.account.name }}
                            </div>
                            <div
                              v-if="seller.account.pk == currentUser.account.pk && seller.account.name"
                              class="subtitle is-size-6">
                              {{ seller.profil | profilTypeLabel }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="column is-narrow has-text-right">
                        <button
                          class="button is-action is-circle"
                          @click.prevent.stop="seller = null; contact = null; selfDenunciation = true; getContactsCount()">
                          <i class="fal fa-times"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    class="has-background-annonce columns is-vcentered is-gapless"
                    v-if="displayErrorMessage">
                    <div class="column is-narrow is-padding-small">
                      <span class="icon has-text-white"><i class="fas fa-engine-warning fa-lg"></i></span>
                    </div>
                    <div class="column is-padding-left-xxsmall is-padding-right-xsmall is-padding-top-xsmall is-padding-bottom-xsmall">
                      <div class="has-text-white is-italic is-size-6">
                        <span v-if="!sellerHasAccess">La société de l'utilisateur n'a pas de mandat pour ce lot.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="seller && contactsCount !== null && contactsCount === 0"
                  class="column is-12 columns is-paddingless is-gapless">
                  <div class="column is-12 is-paddingless">
                    <div class="notification is-warning is-size-6 is-padding-top-small is-padding-bottom-small">
                      <p>
                        {{ isSeller || selfDenunciation ? 'Vous ne possédez' : 'Ce vendeur ne possède' }} pas de contact
                        actuellement.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="is-margin-top-xsmall">
                  <div
                    class=""
                    v-if="!contact">
                    <div class="field has-addons">
                      <div
                        v-if="contactsCount && contactsCount > 0"
                        class="control is-expanded">
                        <button
                          class="button is-blocAdd is-fullwidth"
                          style="justify-content: center !important; font-size: 1.13rem"
                          :class="isDisabled"
                          @click.prevent.stop="openContactSelection('simple')"
                          :disabled="isDisabled">
                          <span class="has-text-black"> Sélectionner un contact</span>
                        </button>
                      </div>
                      <div class="control is-expanded">
                        <button
                          class="button is-blocAdd is-fullwidth"
                          style="justify-content: center !important; font-size: 1.13rem"
                          :class="isDisabled"
                          @click.prevent.stop="newContact()"
                          :disabled="isDisabled">
                          <span class="has-text-black"> Créer un nouveau contact</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="contact"
                    class="is-padding-left-xsmall is-padding-top-small is-padding-bottom-small is-padding-right-small is-border">
                    <div class="columns is-gapless">
                      <div class="column">
                        <div class="is-margin-left-xxsmall is-margin-right-xxsmall">
                          <div
                            style="height: 8px !important"
                            class="title is-4">
                            <b>{{ contact.first_name }} {{ contact.last_name }}</b>
                          </div>
                          <div class="rows">
                            <div>
                              <div>
                                <span class="has-text-weight-bold is-size-6">Mail : </span>
                                <span class="is-size-6">{{ contact.email || 'NC' }}</span>
                                -
                                <span class="has-text-weight-bold is-size-6">Téléphone : </span>
                                <phone-number
                                  v-if="contact.phone"
                                  :phone-class="'is-size-6'"
                                  :phone="contact.phone"></phone-number>
                              </div>
                              <div>
                                <span class="has-text-weight-bold is-size-6">Adresse : </span>
                                <span class="is-size-6">{{ contact.address|prettyInlineAddress }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="column is-narrow">
                        <button
                          class="button is-action is-circle"
                          @click.prevent.stop="contact = null; contactIsInClaim = false">
                          <i class="fal fa-times"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="!contactIsValid || contactIsInClaim"
                  class="has-background-annonce">
                  <div class="columns is-padding-left is-gapless">
                    <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall">
                      <span class="icon has-text-white"><i class="fas fa-engine-warning fa-lg"></i></span>
                    </div>
                    <div class="column is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall">
                      <div class="has-text-white is-italic is-size-6">
                        <span v-if="!contactIsValid">Le contact n'est pas complet. <span
                          @click="completeContact"
                          class="has-cursor-pointer is-underline">Compléter contact</span></span>
                        <span v-else-if="contactIsInClaim">Le contact fait déjà l'objet d'une dénonciation sur ce programme.</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="column columns is-gapless is-column is-space-between is-marginless">
                <div
                  style="width: 100% !important; height: 100% !important;"
                  v-if="program && program.picture"
                  class="is-vcentered is-gapless">
                  <div
                    style="height: 210px"
                    :style="backgroundImageStyle(program.picture)"></div>
                </div>
                <div
                  v-else
                  style="height: 100%; min-height: 240px"
                  class="column columns is-gapless is-column is-space-between is-marginless">
                  <img
                    class="full-background"
                    src="img/placeholder/place-holder-program--small-min.jpg">
                </div>
              </div>
            </div>
          </div>
          <submit-sticky-buttons
            @submit="submitDenunciation"
            :disabled="!contactIsValid || displayErrorMessage || contactIsInClaim"
            :loading="submitLoading"
            button-id="accessForm"></submit-sticky-buttons>
        </form>
      </div>
      <template
        v-if="lot || program"
        slot="right-col-small">
        <div class="is-border has-text-justified">
          <div class="is-padding has-background-light--darken1">
            <div class="title is-4">
              <b>Le saviez-vous ?</b>
            </div>
          </div>
          <div class="has-text-grey is-padding">
            <p v-html="contentFullText"></p>
          </div>
        </div>
      </template>
    </page-content>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { DefaultValues, Quickview } from '@/mixins'
import { concat, isObject } from 'lodash'
import ErrorMixin from '@/mixins/ErrorMixin'
const showdown = require('showdown')

export default {
  name: 'DenunciationCreate',
  mixins: [Quickview, DefaultValues, ErrorMixin],
  data () {
    return {
      contactIsInClaim: false,
      allDenunciation: [],
      selfDenunciation: true,
      lot: null,
      program: null,
      contact: null,
      seller: null,
      sellersCount: null,
      contactsCount: null,
      submitLoading: false,
      accessesList: [],
      contentFullText: null,
      lotRoute: null,
      programRoute: null,
      allotmentList: [],
      duplicateContact: false,
      duplicateDenunciation: false,
      mandatList: [],
      userAllotment: [],
      userAllotmentData: []
    }
  },
  computed: {
    ...mapState(['currentUser', 'quickview', 'savedFilters']),
    ...mapGetters(['isManager', 'isAdmin', 'isPromoteur', 'canAddUsers']),
    /**
      * contact to disabled
      * @return {boolean}
      */
    isDisabled () {
      if (this.seller || this.selfDenunciation) return false
      else return true // 'has-content-disabled has-text-grey is-disabled'
    },
    /**
      * pk of lot
      * @return {string}
      */
    programPk () {
      return this.$route.query.program
    },
    /**
      * pk of lot
      * @return {string}
      */
    lotPk () {
      return this.$route.query.lot
    },
    /**
      * seller has accesss
      * @return {boolean}
      */
    sellerHasAccess () {
      if (this.seller) {
        this.getContactsCount()
        let accessAccountPk = []
        let accessPromoteurPk = []
        let accessWithAllotmentPk = []
        let allAccessWithAllotmentPk = []
        let accountWithAllotmentPk = []
        let allAccountWithAllotmentPk = []
        for (let allotment of this.allotmentList) {
          if (allotment.lot.pk === this.lotPk) {
            accessWithAllotmentPk.push(allotment.access)
            accessWithAllotmentPk.push(allotment.mandat)
          }
          allAccessWithAllotmentPk.push(allotment.access)
          allAccessWithAllotmentPk.push(allotment.mandat)
        }
        for (let access of this.accessesList) {
          if (accessWithAllotmentPk.includes(access.pk)) {
            accountWithAllotmentPk.push(access.account)
          }
          if (allAccessWithAllotmentPk.includes(access.pk)) {
            allAccountWithAllotmentPk.push(access.account)
          }
          accessAccountPk.push(access.account)
          accessPromoteurPk.push(access.promoteur)
        }
        for (let access of this.mandatList) {
          if (accessWithAllotmentPk.includes(access.pk)) {
            access.accounts.forEach(account => {
              accountWithAllotmentPk.push(account)
            })
          }
          if (allAccessWithAllotmentPk.includes(access.pk)) {
            access.accounts.forEach(account => {
              allAccountWithAllotmentPk.push(account)
            })
          }
          access.accounts.forEach(account => {
            accessAccountPk.push(account)
          })
          accessPromoteurPk.push(access.promoteur)
        }
        // check mandat
        if ((accessPromoteurPk.includes(this.seller.account.pk) || accessAccountPk.includes(this.seller.account.pk)) || (this.program && this.program.promoteur && this.program.promoteur.pk === this.seller.account.pk) || (this.lot && this.lot.promoteur && this.lot.promoteur.pk === this.seller.account.pk)) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },
    /**
      * contact is active
      * @return {boolean}
      */
    contactIsValid () {
      if (this.contact) {
        return this.contact.first_name != null && this.contact.last_name != null && this.contact.phone != null && this.contact.email != null && this.contact.title != null
      } else {
        return true
      }
    },
    /**
      * true if seller don't have access
      * @return {boolean}
      */
    displayErrorMessage () {
      return this.seller && !this.sellerHasAccess
    },
    /**
      * title
      * @return {string} - title
      */
    titleCreate () {
      if (this.lot) {
        return 'Nouvelle Dénonciation ' + this.lot.ref + ' ' + this.lot.program.name
      } else if (this.program) {
        return 'Nouvelle Dénonciation ' + ' ' + this.program.name
      } else {
        return null
      }
    },
    /**
      * contact wo are already claimed
      * @return {array} - array of pk to exclude
      */
    excludedContactPk () {
      let tab = []
      if (this.contact) {
        tab.push(this.contact.pk)
      }
      if (this.allDenunciation.length) {
        tab = tab.concat(this.allDenunciation.map(x => x.contact.pk))
      }
      return tab
    }
  },
  watch: {
    '$route.query.lot': {
      handler: 'setLot',
      immediate: true
    },
    '$route.query.program': {
      handler: 'setProgram',
      immediate: true
    },
    // '$route' (to, from) {
    //   this.lotRoute = this.lotPk
    // },
    // '$route' (to, from) {
    //   this.programRoute = this.programPk
    // }
    /**
      * watch if claim is for current user
      */
    selfDenunciation (v) {
      this.contact = null
      this.seller = null
      if (this.isManager && !this.currentUser.active_all_contact) {
        this.getSellersCount()
      }
      return this.getContactsCount()
    },
    async quickview ({ mode, params, results }) {
      if (results && mode === 'USER_SELECTION') {
        if (results.entities.length) {
          if ('account_type' in results.entities[0]) {
            let user = await this.getUser(results.entities[0].first_admin.pk)
            await this.getUserAllotment(user)
            this.seller = Object.assign({}, user)
          } else {
            await this.getUserAllotment(results.entities[0])
            this.seller = Object.assign({}, results.entities[0])
          }
          this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
        } else {
          this.$toasted.global.danger('Veuillez sélectionner un utilisateur')
        }
      } else if (mode === 'CONTACT_SELECTION' && results) {
        if (results.entities.length) {
          this.addContact(results.entities[0])
        } else {
          this.$toasted.global.danger('Veuillez sélectionner un contact')
        }
      } else if (mode === 'CONTACT_CREATE' && results) {
        let check = 'CONTACT_CREATE'
        this.verifBeforeCreateContact(results.contact, check)
      } else if (mode === 'CONTACT_UPDATE' && results) {
        let check = 'CONTACT_UPDATE'
        this.verifBeforeCreateContact(results.contact, check)
      } else if (mode === 'CONTACT_CHECK_UPDATE' && results) {
        let doublon = true
        this.updateContact(results.contact, doublon)
      } else if (mode === 'CONTACT_CHECK_CREATE' && results) {
        let doublon = true
        this.createContact(results.contact, doublon)
      }
    }
  },
  async created () {
    // await this.setProgram()
    await this.getContactsCount()
    await this.getLot()
    await this.getProgram()
    await this.getProgramAccesses()
    await this.getProgramAllotment()
    await this.getProgramMandatType()
    await this.getHelper()
  },
  methods: {
    async setProgram (_new, old) {
      if (_new) {
        await this.getProgram()
      }
    },
    async setLot (_new, old) {
      if (_new) {
        await this.getLot()
      }
    },
    async getUser (id) {
      try {
        let { data } = await this.$api.getOne(this.$resources.USER, id)
        return data
      } catch (e) {
        console.log(e)
      }
    },
    async getHelper () {
      let id = '5wcEl6MgRaWSsufxikxsrN'
      if (id && this.$contentful) {
        this.$contentful.getEntry(id).then(entry => {
          let converter = new showdown.Converter()
          let text = entry.fields.text
          this.contentFullText = converter.makeHtml(text)
        })
      }
    },
    /**
      * add contact
      * @param {object} - contact
      */
    async addContact (contact) {
      this.contact = await this.returnContact(contact.pk)
      this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
      this.checkContact()
    },
    /**
      * get complete contact
      * @param {string} - id
      * @return {object} - return contact
      */
    async returnContact (id) {
      try {
        let { data } = await this.$api.getOne(this.$resources.CONTACT, id)
        return data
      } catch (err) {
        console.log(err)
      }
    },
    /**
      * get complete contact
      */
    async completeContact () {
      try {
        await this.getContact()
        await this.$store.commit('setClaimCreateContact', true)
        this.openUpdateContactQuickview(this.contact)
      } catch (err) {
        console.log(err)
      }
    },
    /**
      * get contact
      */
    async getContact () {
      try {
        let { data } = await this.$api.getOne(this.$resources.CONTACT, this.contact.pk)
        this.contact = data
      } catch (err) {
        console.log(err)
      }
    },
    /**
      * open contact selection
      */
    newContact () {
      this.$store.commit('setClaimCreateContact', true)
      this.openNewContactQuickview()
    },
    /**
      * check if contact is in claim
      */
    async checkContact () {
      await this.getAllDenunciation()
      let isContactInClaim = this.allDenunciation.find(x => x.contact.pk.includes(this.contact.pk))
      if (this.lot !== null) {
        if (isContactInClaim && isContactInClaim.program.pk === this.lot.program.pk) {
          this.contactIsInClaim = true
        } else {
          this.contactIsInClaim = false
        }
      } else if (this.program !== null) {
        if (isContactInClaim && isContactInClaim.program.pk === this.program.pk) {
          this.contactIsInClaim = true
        } else {
          this.contactIsInClaim = false
        }
      }
    },
    /**
      * get claims list
      * @param {object} page
      */
    async getAllDenunciation (page = 1) {
      let query = {
        page,
        per_page: 100,
        status: ['pending', 'approved']
      }
      try {
        let request = await this.$api.get(this.$resources.CLAIM, query)
        if (page > 1) {
          let totalDenunciation = concat(request.data.items, this.allDenunciation)
          this.allDenunciation = totalDenunciation
        } else {
          this.allDenunciation = request.data.items
        }
        if (request.data.page < request.data.pages) {
          page++
          this.getAllDenunciation(page)
        }
      } catch (err) {
        console.log(err)
      }
    },
    /**
      * check contact en doublon
      * @param {object} contact - contact to check
      */
    async verifBeforeCreateContact (contact, check) {
      this.$store.commit('setQuickviewLoading', true)
      if (!contact.user) {
        if (this.seller && this.seller.account.pk === this.currentUser.account.pk) {
          contact.user = this.seller.pk
        } else {
          contact.user = this.currentUser.pk
        }
      }
      if (contact.last_name === null || contact.last_name === '') {
        this.$toasted.global.danger('Veuillez renseignez un nom au contact')
        this.$store.commit('setQuickviewLoading', false)
        return
      }

      if (contact.first_name === null || contact.first_name === '') {
        this.$toasted.global.danger('Veuillez renseignez un prénom au contact')
        this.$store.commit('setQuickviewLoading', false)
        return
      }

      if (contact.email === null || contact.email === '') {
        this.$toasted.global.danger('Veuillez renseignez un email au contact')
        this.$store.commit('setQuickviewLoading', false)
        return
      }

      if (contact.phone === null || contact.phone === '') {
        this.$toasted.global.danger('Veuillez renseignez un numéro de téléphone au contact')
        this.$store.commit('setQuickviewLoading', false)
        return
      }
      try {
        this.$store.commit('setQuickviewLoading', false)
        let contactUser = null
        if (this.seller && this.seller.pk) {
          contactUser = this.seller.pk
        } else {
          contactUser = contact.user
        }
        let payload = {
          contact: this.$cleanPayload(contact),
          user: contactUser
        }
        let { data } = await this.$api.post(this.$resources.CONTACT_CHECK, payload)
        if (data.duplicates.length !== 0 || data.all_pk_contact.length !== 0) {
          data.duplicates.length !== 0 ? this.duplicateDenunciation = true : this.duplicateDenunciation = false
          data.all_pk_contact.length !== 0 ? this.duplicateContact = true : this.duplicateContact = false
          let alert = true
          await this.$store.commit('setClaimCreateContact', true)
          if (check === 'CONTACT_CREATE') {
            this.openNewContactQuickview({}, contact, alert, data)
          } else if (check === 'CONTACT_UPDATE') {
            this.openUpdateContactQuickview(contact, alert, data)
          }
        } else {
          if (check === 'CONTACT_CREATE') {
            this.createContact(contact)
          } else if (check === 'CONTACT_UPDATE') {
            this.updateContact(contact)
          }
        }
      } catch (e) {
        this.loading = false
        this.$store.commit('setQuickviewLoading', false)
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
    },
    /**
      * create contact from quickview
      * @param {object} contact - contact to create
      */
    async createContact (contact, doublon) {
      this.duplicateContact = this.duplicateContact === true ? contact.doublon_contact = true : contact.doublon_contact = false
      this.duplicateDenunciation = this.duplicateDenunciation === true ? contact.doublon_denunciation = true : contact.doublon_denunciation = false
      contact.original_program = this.program.pk
      try {
        let { data } = await this.$api.post(this.$resources.CONTACT, this.$cleanPayload(contact))
        data = data.json_data
        this.contact = data
        this.loading = false
        this.$toasted.global.success('Contact ajouté')
        this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
        this.$store.commit('setQuickviewLoading', false)
        if (this.seller) {
          this.getContactsCount()
        }
        await this.$store.commit('setClaimCreateContact', false)
      } catch (e) {
        console.log(e)
        this.loading = false
        this.$store.commit('setQuickviewLoading', false)
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
    },
    /**
      * update contact from quickview
      * @param {object} contact - contact to update
      */
    async updateContact (contact, doublon) {
      if (doublon) {
        contact.doublon = doublon
      }
      if (Array.isArray(contact.programs) && isObject(contact.programs[0])) {
        contact.programs = [contact.programs[0].pk]
      }
      if (contact.original_program && contact.original_program.pk) {
        contact.original_program = contact.original_program.pk
      }

      try {
        let { data } = await this.$api.put(this.$resources.CONTACT, contact.pk, this.$cleanPayload(contact))
        this.contact = data
        this.$toasted.global.success('Contact modifié')
        this.$store.commit('setQuickviewLoading', false)
        this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
      } catch (e) {
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
        this.$store.commit('setQuickviewLoading', false)
      }
    },
    /**
      * prepare parms for the user selection
      */
    openUserSelection (type = 'multiple') {
      let params
      if ((this.isAdmin && this.isPromoteur)) {
        params = {
          searchKeys: ['USER', 'ACCOUNT'],
          facets: {
            USER: [
              [`pk:-${this.currentUser.pk}`]
            ],
            ACCOUNT: []
          },
          selectType: type,
          mode: 'store'
        }
      } else if (this.isManager && this.currentUser.active_all_contact) {
        params = {
          searchKeys: ['USER'],
          facets: {
            USER: [
              [`account.pk:${this.currentUser.account.pk}`]
            ]
          },
          selectType: type,
          mode: 'store'
        }
      } else {
        params = {
          facets: {
            USER: [
              [`pk:-${this.currentUser.pk}`]
            ]
          },
          selectType: type,
          mode: 'store'
        }
      }

      if (this.isManager && !this.currentUser.active_all_contact) {
        params.facets.USER.push([`manager.pk:${this.currentUser.pk}`])
      }

      this.openUserSelectionQuickview(params)
    },
    // /**
    //   * get access of program
    //   */
    async getProgramAccesses () {
      let params = {}
      if (this.lot !== null) {
        params = { params: this.lot.program.pk }
      } else if (this.program !== null) {
        params = { params: this.program.pk }
      }
      try {
        let { data } = await this.$api.get(this.$resources.ACCESS_ALL, params)
        this.accessesList = data.all_mandats
      } catch (e) {
        console.log(e)
      }
    },
    async getProgramAllotment () {
      if (this.lot !== null) {
        let params = { params: this.lot.pk }
        try {
          let { data } = await this.$api.get(this.$resources.ALLOTMENT_ALL, params)
          this.allotmentList = data.all_allotment
        } catch (e) {
          console.log(e)
        }
      }
    },
    async getUserAllotment (seller) {
      if (this.lot !== null) {
        let params = { user: seller.account.pk }
        try {
          let { data } = await this.$api.get(this.$resources.ALLOTMENT_ALL, params)
          data.all_allotment.forEach(allotment => {
            this.userAllotment.push(allotment.lot.pk)
          })
        } catch (e) {
          console.log(e)
        }
      }
    },
    async getProgramMandatType () {
      let params = null
      if (this.lot !== null) {
        params = this.lot.program.pk
      } else if (this.program !== null) {
        params = this.program.pk
      }
      try {
        let { data } = await this.$api.get(this.$resources.CHANNELS)
        for (let c of data.items) {
          let payload = {
            sales_channel: c.pk
          }
          let { data } = await this.$api.get(this.$resources.MANDAT, payload)
          for (let mandat of data.items) {
            if (params === mandat.program.pk) {
              this.mandatList.push(mandat)
            }
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    /**
      * get counts of sellers
      */
    async getSellersCount () {
      let query = {
        per_page: 1,
        manager: this.currentUser.pk
      }
      const { data } = await this.$api.get(this.$resources.USER, query)
      this.sellersCount = data.count
    },
    /**
      * get counts of contacts
      */
    async getContactsCount () {
      let query = {
        per_page: 1
      }
      if (this.seller) {
        query.user = this.seller.pk
      }
      const { data } = await this.$api.get(this.$resources.CONTACT, query)
      this.contactsCount = data.count
    },
    /**
      * prepare parms for the contact selection
      */
    openContactSelection (type = 'multiple') {
      if (this.seller || this.selfDenunciation) {
        let params = {
          facets: {
            CONTACT: []
          },
          selectType: type,
          mode: 'store'
        }
        for (let exclude of this.excludedContactPk) {
          params.facets.CONTACT.push([`pk:-${exclude}`])
        }
        if (this.isSeller || this.selfDenunciation) {
          params.facets.CONTACT.push([`user.pk:${this.currentUser.pk}`])
        } else {
          params.facets.CONTACT.push([`user.pk:${this.seller.pk}`])
        }
        this.openContactSelectionQuickview({ params })
      }
    },
    /**
      * submit confirmation
      */
    confirmSubmit () {
      return this.$swal({
        title: 'Envoi des coordonnées contact',
        text: 'Pour garantir la dénonciation auprès du promoteur, les coordonnées du contact lui seront envoyées.',
        cancelButtonText: 'Annuler',
        confirmButtonText: 'Valider',
        customClass: {
          confirmButton: 'is-danger'
        }
      })
    },
    /**
      * submit denunciation
      */
    async submitDenunciation () {
      if (!this.seller && this.selfDenunciation === false) {
        this.$toasted.global.danger('Veuillez renseigner un vendeur')
        return
      }
      if (!this.contact) {
        this.$toasted.global.danger('Veuillez renseigner un contact')
        return
      }
      let value = await this.confirmSubmit()
      if (value.dismiss) return false // ON ne supprimme pas l'utilisateur
      if (value) {
        this.submitLoading = true
        let params = {
          contact: this.contact.pk
        }
        if (this.lot) {
          params = { ...params,
            program: this.lot.program.pk,
            promoteur: this.lot.promoteur.pk
          }
        } else {
          params = { ...params,
            program: this.program.pk,
            promoteur: this.program.promoteur.pk }
        }

        if (this.seller && this.seller.account.pk !== this.currentUser.account.pk) {
          params = { ...params,
            promoteur: this.seller.pk }
        } else if (this.seller) {
          params = { ...params,
            promoteur: this.seller.pk }
        } else {
          params = { ...params,
            promoteur: this.currentUser.pk }
        }
        try {
          let { data } = await this.$api.post(this.$resources.CLAIM, params)
          this.$store.commit('addRunningDenunciation', { denunciation: data })
          this.$toasted.global.success('Dénonciation effectuée')
          this.$router.replace({ name: 'DenunciationList' })
          this.submitLoading = false
        } catch (e) {
          console.log(e)
          this.handleError(e)
          this.submitLoading = false
        }
      }
    },
    /**
      * get list of lots
      */
    async getLot () {
      if (this.lotPk) {
        try {
          let { data } = await this.$api.getOne(this.$resources.LOT, this.lotPk)
          this.lot = data
        } catch (err) {
          console.log(err)
        }
        try {
          let { data } = await this.$api.getOne(this.$resources.PROGRAM, this.lot.program.pk)
          this.program = data
        } catch (err) {
          console.log(err)
        }
      }
    },
    /**
      * get list of lots
      */
    async getProgram () {
      if (!this.lotPk) {
        try {
          let { data } = await this.$api.getOne(this.$resources.PROGRAM, this.programPk)
          this.program = data
        } catch (err) {
          console.log(err)
        }
      }
    },
    backgroundImageStyle (picture) {
      return {
        backgroundImage: `url('${picture.path}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        height: '100%',
        width: '100%'
      }
    }
  }
}
</script>

<style scoped>
.button.is-blocAdd {
  min-height: 50px !important
}

.button.is-blocAdd span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.semidarkcolor-title {
  color: #363636;
  font-weight: 500;
  line-height: 1.125;
}

.full-background {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
}
</style>
